module.exports = __webpack_public_path__ + "static/banner-blue-4975076173f994591f1fc992b2c37884.svg";